// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__f6WYG","content":"LoadingAlert_content__shkRi"};